import { FC } from "react";
import { UserDefaultIcon } from "shared/ui/icons";

import styles from "./RaffleTable.module.css";

// Имён и аватаров в API нет: только fid и заглушка.
export const RaffleUserCell: FC<{ fid: number }> = ({ fid }) => (
  <span className={styles.user}>
    <UserDefaultIcon
      className={styles.avatar}
      width={22}
      height={22}
      fill="currentColor"
    />
    {fid}
  </span>
);
